import { render, staticRenderFns } from "./MetalAttributes.vue?vue&type=template&id=97a9effa&scoped=true"
import script from "./MetalAttributes.vue?vue&type=script&lang=js"
export * from "./MetalAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a9effa",
  null
  
)

export default component.exports